<hr />
<div class="row my-2">
  <div class="col-sm-4">
    <h6>
      <img
        class="p-2"
        ngSrc="assets/images/icons/tanques.svg"
        alt="Tanques"
        height="50"
        width="50"
      />{{ entityName }}
    </h6>
  </div>
  <div class="col-sm-8 text-end">
    <div class="input-search-container-new">
      <span class="material-symbols-outlined search-icon"> search </span>
      <input
        placeholder="Buscar"
        class="input-search-datatable"
        id="custom-search-input"
        type="text"
        [(ngModel)]="searchText"
        (input)="applyFilter()"
      />
    </div>
    <button
      id="tanques-list-new"
      class="btn-btn-create"
      (click)="onNewTanque()"
      *ngIf="showButton('create')"
    >
      Crear {{ entityName }}
    </button>
    <button
      id="tanques-list-refresh"
      class="btn mx-2 btn-refresh"
      (click)="onRefresh()"
    >
      <span class="material-symbols-outlined"> refresh </span>
    </button>
  </div>
</div>
<div class="row">
  <div class="text-center my-5" *ngIf="isGettingTanques">
    <app-spinner message="Cargando {{ entityName }}"></app-spinner>
  </div>
  <div class="col-xs-12">
    <div class="table-responsive-sm" *ngIf="!isGettingTanques">
      <table
        datatable
        [dtOptions]="dtOptions"
        class="table display nowrap"
        style="width: 100%"
      >
        <caption>
          Lista de Vehículos
        </caption>
        <thead>
          <tr class="text-center">
            <th
              scope="col"
              *ngFor="let attribute of tanquesAttributes"
              [hidden]="hideColumn(attribute)"
            >
              {{ attribute }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let tanque of tanques">
            <td>
              <a
                id="tanques-list-{{ tanque.licensePlate }}"
                (click)="onSelectedTanque(tanque)"
                style="color: #0d6efd"
                >{{ tanque.sapId! | sapId }}</a
              >
            </td>
            <td>
              <span>
                <img
                  [ngSrc]="getImageSrc(tanque.status)"
                  height="25"
                  width="25"
                  alt="Estado"
                />
              </span>
              {{ tanque.status | master : "VEHICLES#STATUSES" }}
            </td>
            <td>{{ tanque.licensePlate }}</td>
            <td [hidden]="hideColumn('Transportista')">
              {{ tanque.carrier!.name }}
            </td>
            <td>{{ tanque.center | master : "CENTERS" }}</td>
            <td>
              <span
                class="badge border rounded-4 text-bg-light mx-1"
                *ngIf="hasToExpireDocuments(tanque)"
              >
                <span class="badge border rounded-circle text-bg-light">{{
                  tanque.documentsToExpire
                }}</span>
                por vencer</span
              >
              <span
                class="badge border rounded-4 text-bg-light mx-1"
                *ngIf="hasExpiredDocuments(tanque)"
              >
                <span class="badge border rounded-circle text-bg-light">{{
                  tanque.documentsExpired
                }}</span>
                vencido</span
              >
            </td>
            <td>
              <span
                class="badge border rounded-4 text-bg-light mx-1"
                *ngFor="let blockingMotive of tanque.blockingMotives"
              >
                {{ blockingMotive }}</span
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
